import store from '@/store'
import { getFollowInfo } from '../../utils/http/modules/agent/agent.request'

/**
 * * 代理中心 - 代理相关 公共业务控制器
 * */
class AgentMainController {
  /**
   * 判断当前代理业务模式
   * @param {Number|null} model - 要比较的业务模式数值，可选
   * @returns {Boolean|Number} - 如果有传入model，返回比较结果(布尔值)；如果没有传入，则直接返回当前业务模式值
   */
  static getBusinessModel(model = null) {
    const getters = store.getters || {}
    const authData = getters.getAuthDataAndAgentSetting || {}
    const agentSetting = authData.agentSetting || {}
    const businessModel = agentSetting.businessModel
    // 1. 如果有传入model，判断是否等于当前业务模式
    if (model !== null) {
      return businessModel === model
    }
    // 2. 如果没有传入model，直接返回当前业务模式值
    return businessModel
  }
  static getActiveNum() {
    if (AgentMainController.getBusinessModel(2)) {
      return 0
    } else {
      return 2
    }
  }

  /**
   * 获取用户跟进人信息的公共封装（使用缓存）
   * @param {Object} params - 请求参数
   * @param {String} params.zbId - 直播ID
   * @param {Boolean} [params.useCache=true] - 是否使用缓存结果
   * @returns {Promise<Object>} - 返回关注信息的Promise
   */
  static async getFollowInfo(params) {
    try {
      // 确保必要参数
      if (!params || !params.zbId) {
        throw new Error('zbId参数必须提供')
      }

      // 默认使用缓存
      const useCache = params.useCache !== false

      // 生成缓存key：zbId + 其他可能影响结果的参数
      const cacheKey = `follow_info_${params.zbId}`

      // 如果使用缓存且缓存中有数据，则直接返回缓存数据
      if (useCache) {
        const state = store.state || {}
        const cachedData =
          state.followInfoCache && state.followInfoCache[cacheKey]
        if (cachedData) {
          return cachedData
        }
      }

      // 缓存不存在或不使用缓存，调用API获取数据
      delete params.useCache
      const response = await getFollowInfo(params)

      // 如果获取成功，则更新缓存
      if (response && response.dataObj) {
        // 更新Vuex缓存
        store.commit('setFollowInfoCache', {
          key: cacheKey,
          data: response,
        })
      }
      return response
    } catch (error) {
      console.error('获取关注信息失败:', error)
      throw error
    }
  }
}

export default AgentMainController
